import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

/**
 * 條碼生成器元件
 * @param {Object} props - 元件屬性
 * @param {string} props.value - 條碼內容值（預設：'A1234567890'）
 * @param {Object} props.options - JsBarcode 配置選項
 * @param {string} props.options.format - 條碼格式（預設：'CODE128'）
 *   可選值：'CODE128'|'EAN13'|'UPC'|'EAN8'|'EAN5'|'EAN2'|'CODE39'|'ITF14'|'MSI'|'pharmacode'|'codabar'
 * @param {number} props.options.width - 條碼每個位的寬度（預設：2）
 * @param {number} props.options.height - 條碼高度（預設：100）
 * @param {boolean} props.options.displayValue - 是否顯示條碼文字（預設：true）
 * @param {number} props.options.margin - 條碼四周邊距（預設：20）
 * @param {string} props.options.background - 背景顏色（預設：'#ffffff'）
 * @param {string} props.options.lineColor - 條碼線條顏色（預設：'#000000'）
 * @param {boolean} props.options.valid - 條碼驗證函數（預設：function）
 * @param {string} props.options.font - 文字字型（預設：'monospace'）
 * @param {string} props.options.fontOptions - 字型選項（預設：''）
 * @param {number} props.options.fontSize - 字型大小（預設：20）
 * @param {string} props.options.textAlign - 文字對齊方式（預設：'center'）
 * @param {string} props.options.textPosition - 文字位置（預設：'bottom'）
 * @param {number} props.options.textMargin - 文字與條碼間距（預設：2）
 * @param {number} props.options.flat - 扁平化條碼（預設：false）
 */

const BarcodeGenerator = ({ value = 'A1234567890', options }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        if (canvasRef.current) {
            JsBarcode(canvasRef.current, value, {
                format: 'CODE128',
                width: 2,
                height: 100,
                displayValue: true,
                margin: 20,
                ...options,
            });
        }
    }, [value, options]);

    return <canvas ref={canvasRef} />;
};

export default BarcodeGenerator;
